import computeShowRemove from './computeShowRemove';
import computeShowMovable from './computeShowMovable';
import { addOwnerDetailsToLendersPolicy } from './addOwnerDetailsToLendersPolicy';
import { addOriginalTotal } from './addOriginalTotal';
import { generateDefaultViewItems } from './generateDefaultViewItems';
import { removeDuplicateDefaultViewItems } from '../../../ui-toolkit/cdItems/data/removeDuplicatedDefaultViewItems';
import { generateDefaultViewItem } from '../../../ui-toolkit/cdItems/data/generateDefaultViewItem';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { IOwnerDetailsServiceItem } from '../../../ui-toolkit/cdItems/service/ServiceInterfaces';
import { eUnderwriter } from '../../../ui-toolkit/enums/eUnderwriter';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';

export const createCdBuilderPresentationItems = (
  items: ICDV3ViewItem[],
  details: IOwnerDetailsServiceItem,
  parties: IParty[],
  ownerId: string
) => {
  const underwriterParty = parties.find((p) => p.purpose === ePartyPurpose.underwriter);
  const underwriter =
    underwriterParty && underwriterParty.type === ePartyType.entity
      ? (underwriterParty.entity_value as eUnderwriter)
      : undefined;
  const mappedItems = items
    .map((item) => ({
      ...generateDefaultViewItem(),
      ...item,
      removable: computeShowRemove(item, underwriter),
      movable: computeShowMovable(item, underwriter),
    }))
    .map(addOwnerDetailsToLendersPolicy(details))
    .map(addOriginalTotal);
  // FYI: get the default items and remove any of them that have a matching item in the service response
  const defaultUncreatedFees = generateDefaultViewItems(ownerId, details.loanAmount, details.purchasePrice).filter(
    removeDuplicateDefaultViewItems(mappedItems)
  );
  return defaultUncreatedFees.concat(mappedItems);
};
